<template>
  <div class="modal-content select-none">
    <div class="modal-body mobile:!p-2.5 tablet:!p-3 !pb-5">
      <div class="relative">
        <button type="button"
          class="absolute top-3 right-4 w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
          data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
          <img src="@/assets/images/modal-cross-icon.png">
        </button>
        <div class="relative rounded-lg overflow-hidden mobile:h-[70px] tablet:h-[80px]">
          <img src="../../assets/images/profile-bg.png" alt="Background" class="w-full h-auto object-cover">
          <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
            <h4 class="text-[20px] m-0 font-roboto font-medium text-black-100">
              Select Job Service Type
            </h4>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2.5 w-full p-2.5">
        <div class="mt-[20px]">
          <p class="m-0 font-roboto text-[16px] font-normal leading-6 text-[#666666]">
            For this job,
          </p>
          <p class="m-0 font-roboto text-[16px] font-normal leading-6 text-[#666666]">
            will you perform an Evaluation (Repair) or Maintenance?
          </p>
        </div>
        <ul class="p-0 m-0 flex flex-col gap-2 my-3">
          <li v-for="(service, index) in services" :key="index">
            <label
              class="m-0 flex items-center gap-2 p-2 rounded-[5px] cursor-pointer bg-opacity-50 border border-[#EFEFEF] bg-[#EFEFEF]">
              <!-- Native radio hidden -->
              <input v-model="check" :value="service.id" type="radio" class="hidden peer">

              <!-- Custom radio -->
              <span class="w-[16px] h-[16px] border-[1px] rounded-full flex items-center justify-center
                  border-gray-400 bg-white
                  peer-checked:border-[#BA90C6]">
                <!-- Inner dot -->
                <span v-if="check === service.id" class="w-[8px] h-[8px] bg-[#BA90C6] rounded-full" />
              </span>

              <!-- Label text -->
              <span class="font-roboto text-[14px] text-[#333333]">
                {{ service.title }}
              </span>
            </label>
          </li>
        </ul>
        <div class="flex justify-center items-center gap-3 pt-2.5">
          <button type="button"
            class="border-1 py-1.5 px-4 rounded-[5px] cursor-pointer transition duration-300 mobile:text-white laptop:text-[#00B7C2] border-[#00B7C2] mobile:bg-[#00B7C2] laptop:bg-white laptop:hover:bg-[#00B7C2] laptop:hover:text-[#fff]"
            @click="confirm">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- <div id="modalDiscard" class="modal fade modal-md show" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-modal="true" role="dialog" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content !rounded-[20px]">
        <div class="modal-body p-4 pb-5">
          <div class="flex flex-col gap-4 w-full">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2">
                <span class="w-2 h-2 rounded-full bg-[#FE5000]" />
                <span class="w-10 h-2 rounded-full bg-[#FE5000]" />
                <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">
                  Select Job Service Type
                </h2>
              </div>
              <button class="w-[40px] h-[40px] p-2 bg-[#fff]" type="button" data-bs-dismiss="modal" aria-label="Close"
                @click="closeModal">
                <img src="@/assets/images/modal-cross-icon.png">
              </button>
            </div>
            <div>
              <p class="m-0 font-lato text-[16px] text-[#333333]">
                For this job,
              </p>
              <span class="m-0 font-lato text-[16px] text-[#333333]">
                will you perform an Evaluation (Repair) or Maintenance?
              </span>
            </div>
            <ul class="p-0 m-0 flex flex-col gap-2 my-3">
              <li v-for="(service, index) in services" :key="index">
                <label
                  class="m-0 flex items-center gap-2 p-2 rounded-[5px] cursor-pointer bg-opacity-50 border border-[#EFEFEF] bg-[#EFEFEF]">
                  <input v-model="check" :value="service.id" type="radio" class="accent-[#FE5000] ">
                  <span class="font-lato text-[#092E87]">{{ service.title }}</span>
                </label>
              </li>
            </ul>
            <div class="flex justify-center items-center gap-3">
              <span
                class="border-1 py-2 px-5 rounded-full cursor-pointer transition duration-300 text-[#092E87] border-[#092E87] hover:bg-[#092E87] hover:text-[#fff] [@media(max-width:1023px)]:!bg-[#092E87] [@media(max-width:1023px)]:!text-[#fff]"
                @click="confirm">Submit</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import { template } from "lodash";
const toast = useToast();

export default {
  components: {},

  data() {
    return {
      check: 1,
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail", "services"]),
  },

  watch: {},

  mounted() { },

  methods: {
    ...mapActions(["setCommponent"]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },

    closeModal() {
      this.check = 1;
      this.$emit("event", "close");
    },

    confirm() {
      this.$emit("event", "confirm", this.check);
    },
  },
};
</script>
